<ngx-loading [show]="isLoading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading>
<mat-drawer-container [class.opacity-30]="!isCopilotAvailable" [class.pointer-events-none]="!isCopilotAvailable" #drawerContainer class="h-full flex flex-wrap w-full relative dark:bg-gray-900 bg-white" [autosize]="true">
    <mat-drawer #drawer class="shrink-0 overflow-hidden" [opened]="drawerConfig.opened"  [mode]="drawerConfig.mode">
        <app-copilot-drawer [selectedAssetId]="selectedAsset.id" [sessions]="sessions" [userDetail]="userDetail" [selectedSessionId]="assetSessionId"  [drawer]="drawer" [drawerConfig]="drawerConfig" (toggleDrawer)="onBackClicked()"></app-copilot-drawer>
    </mat-drawer>
    <mat-drawer-content class=" flex flex-col w-full pb-2 relative chat-container items-center"
    >
    <header
   
    class="py-1 px-4 sticky top-0  w-full flex justify-between items-center border-b border-divider z-10 dark:bg-gray-900 bg-white">
  
    <!-- Left: Back button -->
    <div class="flex items-center justify-start">
      <div class="flex gap-2">
        <button (click)="onBackClicked()"
          class="flex items-center gap-2 whitespace-nowrap rounded border px-3 py-2 text-sm font-medium transition-colors duration-200 hover:bg-gray-100 text-gray-900 dark:text-white dark:hover:bg-gray-800 dark:bg-gray-700">
          <mat-icon svgIcon="heroicons_outline:arrow-left" class="icon-size-4 text-primary-500"></mat-icon>
          <!-- Hide text on small screens -->
          <span class="hidden sm:inline">Back to Drive</span>
        </button>
      </div>
  
      <!-- Assistants Menu -->
      <mat-menu #assistantsMenu="matMenu" class="rounded-2xl p-2 w-72">
        <ng-container *ngFor="let assistant of settings.assistants">
            <button *ngIf="assistant.enabled" mat-menu-item 
            (click)="selectAssistant(assistant)"
            class="flex flex-col items-start rounded-xl p-3 w-full transition-colors duration-200"
            >
            <div class="flex justify-between items-center w-full">
              <mat-icon [svgIcon]="assistant.icon" class="icon-size-4 text-primary-500"></mat-icon>
              <span class="font-medium text-sm">{{ assistant.name }}</span>
            </div>
          </button>
        </ng-container>

        <mat-divider *ngIf="settings.agents.length" class="my-2"></mat-divider>
        <ng-container *ngFor="let agent of settings.agents">
          <button *ngIf="agent.enabled" mat-menu-item 
          (click)="selectAssistant(agent)"
          class="flex flex-col items-start rounded-xl p-3 w-full transition-colors duration-200"
          >
          <div class="flex justify-between items-center w-full">
            <mat-icon [svgIcon]="agent.icon" class="icon-size-4 text-primary-500"></mat-icon>
            <span class="font-medium text-sm">{{ agent.name }}</span>
          </div>
        </button>
      </ng-container>
      </mat-menu>
    </div>
  
    <!-- Center: File / Folder name -->
    <div class="relative flex items-center gap-2 text-center mx-auto whitespace-nowrap">
      <!-- File Icon -->
      <mat-icon
        *ngIf="selectedAsset.type === 'FILE'"
        class="file-icon-size"
        [svgIcon]="util.getFileTypeImage(selectedAsset.extension)">
      </mat-icon>
    
      <!-- Folder Icon -->
      <mat-icon
        *ngIf="selectedAsset.type === 'FOLDER'"
        [svgIcon]="util.getFileTypeImage('folder')"
        class="file-image text-yellow-300 opacity-80">
      </mat-icon>
    
      <!-- Name -->
      <div class="hidden sm:flex items-center justify-center w-full">
        <span
          class="text-primary-500 text-md truncate max-w-[200px] sm:max-w-[350px] md:max-w-[500px]"
          [title]="selectedAsset.name">
          {{ selectedAsset.name }}
        </span>
      </div>
    
      <!-- Info Icon (for both file and folder) -->
      <button
        *ngIf="selectedAsset"
        mat-icon-button
        class="ml-1 text-gray-500 hover:text-primary-500 transition"
        (click)="toggleModal()"
      >
      <mat-icon class="icon-size-4" svgIcon="heroicons_outline:information-circle"></mat-icon>
      </button>
    
      <!-- Modal -->
      <div
        *ngIf="showModal"
        class="absolute top-full left-1/2 -translate-x-1/2 mt-2 transition-all duration-500 z-50 w-[600px]"
      >
        <div
          class="bg-white dark:bg-gray-900 shadow-2xl rounded-2xl p-4 border border-gray-200 dark:border-gray-700"
        >
          <div class="flex justify-between items-center mb-3">
            <h3 class="text-lg font-semibold text-gray-800 dark:text-gray-200">
              {{ selectedAsset.type === 'FOLDER' ? 'Files' : 'File Details' }}
            </h3>
            <div class="flex gap-1">
            <!-- <button
            [matTooltip]="'View File'"
            *ngIf="selectedAsset.type === 'FILE'"
            mat-icon-button
            class="text-gray-500 hover:text-gray-700 dark:hover:text-gray-300"
            (click)="viewFile(selectedAsset)"
          >
          <mat-icon class="icon-size-4" svgIcon="feather:eye"></mat-icon>
          </button> -->
            <button
            mat-icon-button
            class="text-gray-500 hover:text-gray-700 dark:hover:text-gray-300"
            (click)="showModal = false"
          >
          <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
          </button>
            </div>
           
          </div>
    
          <!-- FOLDER CONTENTS -->
          <div
            *ngIf="selectedAsset.type === 'FOLDER' && scopedAssets.length> 0"
            class="grid grid-cols-2 sm:grid-cols-3 gap-3 max-h-[350px] overflow-y-auto"
          >
            <div
          
              *ngFor="let subAsset of scopedAssets"
              class="flex flex-col items-center p-3 bg-gray-50 dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg cursor-pointer transition"
            >
            <button  (click)="viewFile(subAsset)">
              <img
             
                *ngIf="subAsset.thumbnailUrl"
                [src]="subAsset.thumbnailUrl"
                alt="thumbnail"
                class="w-20 h-20 object-cover rounded-md mb-2 shadow-sm"
              />
              <mat-icon
                *ngIf="!subAsset.thumbnailUrl"
                [svgIcon]="util.getFileTypeImage(subAsset.extension)"
                class="text-gray-400 w-12 h-12 mb-2"
              ></mat-icon>
            </button>
           
              <span class="text-sm text-gray-700 dark:text-gray-300 truncate max-w-[100px]" [title]="subAsset.name">
                {{ subAsset.name }}
              </span>
            </div>
          </div>
    
          <!-- FILE DETAILS -->
          <div *ngIf="selectedAsset.type === 'FILE'" class="flex flex-col items-center text-center">
            <button (click)="viewFile(selectedAsset)" class="flex flex-col items-center">
              <img
              *ngIf="selectedAsset.thumbnailUrl"
              [src]="selectedAsset.thumbnailUrl"
              alt="thumbnail"
              class="w-40 h-40 object-cover rounded-xl mb-4 shadow"
            />
            <mat-icon
              *ngIf="!selectedAsset.thumbnailUrl"
              [svgIcon]="util.getFileTypeImage(selectedAsset.extension)"
              class="text-gray-400 w-20 h-20 mb-3"
            ></mat-icon>
    
            <span class="text-md font-semibold text-gray-800 dark:text-gray-200 mb-1">
              {{ selectedAsset.name }}
            </span>
            </button>
      
          </div>
        </div>
      </div>
    </div>
    
    
    <!-- Right: Actions -->
    <div class="flex gap-1">
      <!-- Assistant Switcher -->
      <button [matMenuTriggerFor]="assistantsMenu"
        class="flex gap-2 ml-2 items-center justify-between rounded border px-3 py-2 text-sm font-medium transition-colors duration-200 hover:bg-gray-100 text-gray-900 dark:text-white dark:hover:bg-gray-800 dark:bg-gray-700">
        <div class="flex items-center gap-2">
          <mat-icon svgIcon="heroicons_outline:sparkles" class="icon-size-4 text-primary-500"></mat-icon>
          <!-- Hide assistant name on small screens -->
          <span class="hidden sm:inline">{{ selectedAssistant?.name || selectedAgent?.name||  "Select an asssitant" }}</span>
        </div>
        <mat-icon svgIcon="heroicons_outline:chevron-down" class="icon-size-4 text-primary-500"></mat-icon>
      </button>
  
    </div>
  
  </header>
  
    <main
        #scrollContainer
        class="flex chat-messages pt-1 relative h-full  w-full justify-center   flex-col items-center gap-8 px-2 "
        [ngClass]="{
        'flex-grow overflow-visible': chatMessages.length === 0,
        'flex-grow-[2] overflow-y-auto': chatMessages.length > 0
      }">
        <!-- Messages Container -->
        <div  class="p-4 space-y-2 w-full h-full max-w-5xl  flex flex-col">
           @if(!isLoading){
                @if(chatMessages.length){
                <div *ngFor="let message of chatMessages ; let i = index" class="flex flex-col  items-start"
                [attr.data-msg-index]="i" [ngClass]="message.sender === 'user' ? 'flex-row-reverse text-right' : ''">

                <div class="max-w-5xl w-full rounded-lg">

                    @if(message.sender == 'user'){
                        <div
                        class="text-base text-default bg-card inline-block px-2 py-1 font-normal leading-relaxed border border-divider"
                        [ngClass]="{
                      'rounded-full': message.messageText.length < 80,
                      'rounded-xl': message.messageText.length >= 80
                    }" [innerHTML]="message.message">
                    </div>  
                    } @else{
                        <div [innerHTML]="message.message" class="  antialiased font-sans leading-relaxed rounded">
                         </div>
                         <div class="message-actions self-start">
                          <button *ngIf="!(i === chatMessages.length - 1 && responseStreamLoading)"
                          matTooltip="{{ copiedIndex === i ? 'Copied!' : 'Copy to clipboard' }}"
                          (click)="copyToClipboard(message.messageText, i)"
                          class="text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 
                                 hover:bg-gray-100 dark:hover:bg-gray-700 dark:bg-gray-900 dark:text-gray-300 rounded p-1 transition-colors">
                  
                      <mat-icon class="icon-size-5 text-current" *ngIf="copiedIndex == i"
                                svgIcon="heroicons_outline:clipboard-document-check">
                      </mat-icon>
                      <mat-icon class="icon-size-4 text-current" *ngIf="copiedIndex !== i"
                                svgIcon="heroicons_outline:clipboard">
                      </mat-icon>
                  </button>
                         </div>
                         <div *ngIf="message.sender === 'copilot' && message?.exportOptions && copilotConfig?.contactIds?.length" class="flex justify-end w-full">
                          <button 
                          [disabled]="message?.exporting"
                          (click)="exportMessageData(message)"
                          class="mx-4"
                          mat-flat-button
                          aria-label="File Manager Action Menu"
                          [color]="'primary'">
                          <mat-icon svgIcon="heroicons_outline:document-arrow-up"></mat-icon>
                          <span class="ml-2">Create Contact</span>
                          <div *ngIf="message?.exporting" class="inline-flex  gap-1 px-3  ml-2">
                            <span class="copilot-response-dot"></span>
                            <span class="copilot-response-dot"></span>
                            <span class="copilot-response-dot"></span>
                         </div>
                      </button>
                         </div>
                    }     
                </div>
                </div>
                <div *ngIf="isMessageReponseError" class="inline-flex items-center justify-between gap-3 px-4 py-1 rounded-md border text-sm
                                       bg-red-50 border-red-200 text-red-700 shadow-sm max-w-md">
                    <div class="flex items-center gap-2">
                        <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="icon-size-5 text-red-500"></mat-icon>
                        <span>Something went wrong. Please try again.</span>
                    </div>
                
                    <button (click)="retryMessage()" id="retry-btn" mat-icon-button matTooltip="Retry" class="text-red-600 hover:bg-red-100 rounded-full">
                        <mat-icon class="icon-size-5" svgIcon="heroicons_outline:arrow-path"></mat-icon>
                    </button>
                </div>

                }
                @else{
                 <div class="no-messages space-y-3 mt-auto mb-auto">
                        <!-- Greetings -->
                        <div class="flex items-center  p-4 rounded-lg">
                            <!-- Text -->
                            <div>
                                <div class="font-semibold dark:text-white text-black">
                                    Hello, <span class="font-semibold">{{userDetail.name}}</span>
                                </div>
                                <div class="text-gray-400 text-sm">
                                    How can I help you today?
                                </div>
                                <!-- Extra Description -->
                                <div  class="text-sm text-gray-500 ">
                                   {{copilotDes}}
                                </div>

                            </div>
                        </div>
        
                        <!-- Suggested Prompts  -->
                        <div *ngIf="displayAssistants && !isLoading" class="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-4 justify-items-center">
                            <ng-container *ngFor="let assistant of settings.assistants">
                                <div 
                                *ngIf="assistant.enabled && assistant.assistantType !== 'QA'"
                                class="w-full max-w-xs p-4 rounded-lg shadow-md cursor-pointer hover:scale-105 transition-transform"
                                [ngClass]="'bg-primary-500'" (click)="selectAssistant(assistant)">
        
                                <mat-icon [svgIcon]="assistant.icon" class="text-white text-2xl mb-2"></mat-icon>
        
                                <h3 class="text-base font-semibold text-white leading-tight">
                                    {{ assistant.name }}
                                </h3>
        
                                <p class="text-white text-xs opacity-90 mt-1 leading-snug">
                                    {{ assistant.code }}
                                </p>
                            </div>
                            </ng-container>
                           
                        </div>
        
                 </div>
                }
            }
            @else{
            <div class="flex items-center justify-center h-full">
                <!-- <mat-spinner diameter="40" class="text-primary"></mat-spinner>
                <span class="ml-2 text-primary">Loading...</span> -->
            </div>
            } 
        </div>

    </main>

    <footer  class="w-full sticky  max-w-5xl chat-input px-6 flex **bg-default** pt-3  justify-center bottom-0   **border-divider**"
    [ngClass]="[
    
    chatMessages.length === 0 ? 'items-start flex-1' : 'items-center'
  ]"
        >
        <button style="top: -32px;" *ngIf="isScrollDownVisible && !isLoading" (click)="scrollToBottom()" matTooltip="Scroll to bottom" class="z-10 absolute  transition-all duration-200 
        text-black dark:text-white p-0 border-0 
        bg-slate-200 dark:bg-gray-800 rounded-full shadow-md flex items-center justify-center">
       <mat-icon class="icon-size-10" svgIcon="heroicons_solid:arrow-down-circle"></mat-icon>
       </button>
         
        <div *ngIf="(isQAMode)" class="w-full **bg-card** text-default rounded-2xl pt-4 pb-2 px-8 flex flex-col gap-2 shadow-md chat-input-box border"
            [ngClass]="isFirstRow ? 'rounded-full' : 'rounded-2xl'">
            
            <!-- Upload Files -->
            <div *ngIf="fileUploader?.queue?.length > 0" class="flex flex-wrap gap-3 mt-1">
                <div *ngFor="let file of fileUploader?.queue"
                    class="flex items-center gap-2 px-3 py-1 border **border-divider** rounded bg-transparent">

                    <span class="material-icons **text-primary** text-md">
                        {{ util.getFileIcon(file.file.name) }}
                    </span>

                    <span class="text-sm">{{ file.file.name }}</span>

                    <div *ngIf="file.isUploading">
                        <mat-progress-spinner diameter="16" mode="indeterminate" color="primary"></mat-progress-spinner>
                    </div>
                    <span *ngIf="!file.isUploading" class="material-icons **text-primary** text-sm">check_circle</span>

                    <button (click)="removeFile(file)">
                        <span class="material-icons **text-hint** **hover:text-warn** text-xs">close</span>
                    </button>
                </div>
            </div>

            <!-- Chat Input Text Area -->
            <textarea #chatAreaInput (keydown.enter)="onEnterKey($event)" [attr.placeholder]="'Ask a question'"
                name="copilotChatArea" [(ngModel)]="prompt" required rows="1"
                class="**placeholder-hint** focus:outline-none border-0 focus:ring-0 focus:border-transparent p-1 w-full  resize-none transition-all focus:shadow-none"
                (input)="adjustTextarea(5)">
            </textarea>

            <!-- Chat Input Actions -->
            <div class="flex justify-between items-center w-full" [ngClass]="{ 'pt-2': !isFirstRow }">

                <div class="flex items-center gap-2">
                    <!-- <button type="button" (click)="fileInput.click()" title="Attach file"
                        class="w-8 h-8 **bg-primary text-on-primary** **hover:bg-primary-hover** transition-all rounded-full flex items-center justify-center shadow-md">
                        <mat-icon svgIcon="mat_outline:attach_file" class="text-xs"></mat-icon>
                    </button>
                    <input type="file" hidden #fileInput (change)="onFileSelected($event)" /> -->
                </div>

                <div class="flex items-center gap-2 " [ngClass]="(isFirstRow) 
                    ? 'absolute top-3 right-3' 
                    : 'relative self-end'">
                    <button *ngIf="responseStreamLoading" type="button" (click)="pauseResponseStream()" title="Pause"
                        class="w-8 h-8 **bg-primary text-on-primary** **hover:bg-primary-hover** transition-all rounded-full flex items-center justify-center shadow-md">
                        <mat-icon svgIcon="mat_outline:pause" class="text-sm"></mat-icon>
                    </button>

                    <button (click)="onSendClick()" matTooltip="Send Message" type="submit"
                        [disabled]="!prompt.trim() || responseStreamLoading" class=" flex items-center justify-center rounded-full cursor-pointer disabled:cursor-not-allowed transition-all shadow-md 
                           text-primary disabled:opacity-40">
                        <mat-icon class="icon-size-10" svgIcon="heroicons_solid:arrow-up-circle"></mat-icon>
                    </button>
                </div>
            </div>
        </div>
    </footer>
</mat-drawer-content >
</mat-drawer-container>